export const lineItemsDefaultColumns = [
  { label: 'Produto', value: 'product_display_name' },
  { label: 'Quantidade', value: 'quantity' },
  { label: 'Valor unit.', value: 'unitary_amount' },
  { label: 'Valor total', value: 'amount' },
];
